package com.partejar.app.core.ui.theme

import androidx.compose.ui.graphics.vector.ImageVector
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.ShieldCheck

// Browser biometrics are unsupported; use a neutral security icon as a fallback.
internal actual val platformBiometricIcon: ImageVector
    get() = Lucide.ShieldCheck
